export type TService = {
    name: string,
    alternateName: string,
    type: string,
    description: string,
    url: string,
    img: string
}

export function createServiceSchema(service: TService) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": service.name,
        "alternateName": service.alternateName,
        "serviceType": service.type,
        "description": service.description,
        "url": service.url,
        "provider": {
            "@type": "Organization",
            "name": "نواتل",
            "url": "https://navatel.ir/",
            "logo": {
            "@type": "ImageObject",
            "url": "https://navatel.ir/img/logo.webp"
            }
        },
        "areaServed": {
            "@type": "Country",
            "name": "IR"
        },
        "isRelatedTo": {
            "@type": "Product",
            "name": "مرکز تلفن ابری نواتل",
            "url": "https://navatel.ir/products/cloud-pbx/"
        },
        "image": service.img,
        "potentialAction": {
            "@type": "OrderAction",
            "target": "https://navatel.ir/products/cloud-pbx/",
            "name": "درخواست دمو"
        }
    }
};